export default "__VITE_ASSET__Dowhz5v0__"